import { LookupType } from "./lookups";

export const INDIVIDUAL = 10;
export const JOINT = 15;
export const TRUST = 20;
export const COMPANY = 30;

export const EntityLegalTypeLookup: Array<LookupType> = [
    { value: INDIVIDUAL, key: "Individual" },
    { value: JOINT, key: "Joint" },
    { value: TRUST, key: "Trust" },
    { value: COMPANY, key: "Company" }
];
